import { render, staticRenderFns } from "./SelectCoursesTable.vue?vue&type=template&id=3161972e"
import script from "./SelectCoursesTable.vue?vue&type=script&lang=js"
export * from "./SelectCoursesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports